import { memo } from 'react';
import ReactPaginate from 'react-paginate';
import { Box } from '@bridebook/ui';
import componentStyles from './pagination.style';
import { Icon } from '@bridebook/aura';
import { ChevronLeft, ChevronRight } from '@bridebook/aura/src/icons';

interface IProps {
  items: number;
  activePage: number;
  onSelect: (item: { selected: number }) => void;
  hrefBuilder?: (index: number) => string;
  maxButtons?: number;
}

const Pagination = ({
  items,
  activePage,
  onSelect,
  hrefBuilder,
  maxButtons: maxButtonsProp,
}: IProps) => {
  const maxButtons = maxButtonsProp || 4;
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper} data-name="pagination">
      <ReactPaginate
        containerClassName="pagination"
        previousLabel={
          <Icon icon={ChevronLeft} className={activePage === 0 ? 'text-space-40' : 'text-space'} />
        }
        nextLabel={
          <Icon
            icon={ChevronRight}
            className={items === activePage + 1 ? 'text-space-40' : 'text-space'}
          />
        }
        hrefBuilder={hrefBuilder}
        pageCount={items}
        pageRangeDisplayed={maxButtons}
        marginPagesDisplayed={1}
        initialPage={activePage}
        forcePage={activePage}
        onPageChange={onSelect}
        disableInitialCallback
        selectedPageRel={null}
      />
    </Box>
  );
};

export default memo(Pagination);
